import camelcase from 'camelcase'
import { InputBox } from './forms/InputBox'
import { UseFormRegister, FieldErrors } from 'react-hook-form'
import * as yup from 'yup'

export interface TextInputData {
  label: string
  dataLabel?: string | null
  required?: boolean
  inputType?: 'password' | 'phone number' | 'email'
  register: UseFormRegister<{ [key: string]: string }>
  errors: FieldErrors<any>
}


export function TextInput({ label, register, dataLabel, required, errors, inputType }: TextInputData) {
  const emailValidationFunction = async (value: any) =>
    await yup.string().email().isValid(value)
      || 'Please enter a valid email address'

  let validationObject = {} as any

  if (inputType === 'email') {
    validationObject.email = emailValidationFunction
  }

  const id = dataLabel || camelcase(label)

  const registerReturn = register(id, {
    required: required ? `${label} is required` : false,
    validate: validationObject,
  })

  return (
    <InputBox
      id={id}
      label={label}
      className={inputType === 'email' ? 'col-span-2' : 'col-span-2 md:col-span-1'}
      register={registerReturn}
      placeholder={label}
      errorMessage={errors?.[id]?.message}
      hideLabel
    />
  )
}
